document.body.addEventListener('click', function(event) {

    if (event.target.closest('.button-wishlist')) {
        let currentEle = event.target.closest('.button-wishlist');
        if (currentEle.classList.contains('customer_login')) {
            let loaderDiv = document.querySelector('.loader_div');
            if (loaderDiv) {
                loaderDiv.classList.remove('hidden');
            }
            currentEle.classList.toggle('addedToWishlist');
            let classStatus = currentEle.classList.contains('addedToWishlist');
            classStatus == true ? dataFormat(currentEle, 'push') : dataFormat(currentEle, 'pop');
                     // Check if the URL contains 'account'
        if (window.location.href.includes('account')) {
            let parentLi = currentEle.closest('li');
            if (parentLi) {
            let dataId = parentLi.getAttribute('data-id');
            if (dataId) {
                document.querySelectorAll(`li[data-id="${dataId}"]`).forEach(li => {
                    li.classList.add('hidden');
                });
            }
        }
          // Show your wishlist is empty text if all wishlist items removed
          const wishlistContainer = document.querySelector('.main-dashboard #product-grid');
          const wishlistProducts = wishlistContainer.querySelectorAll('.wishlist-grid-item.hidden');
          const childElementsCount = wishlistContainer.children.length;
          const emptyWishlistMsg = document.querySelectorAll('.wishlistempty');
          const accountWishlistEl = document.querySelector('.account-wishlist__container');
          
          // Check if the count of wishlistProducts matches the count of child elements
          if (wishlistProducts.length === childElementsCount) {
            emptyWishlistMsg.forEach((each) => each.classList.remove('hidden'));
            accountWishlistEl?.classList.add('hidden');
          } else {
              emptyWishlistMsg.forEach((each) => each.classList.add('hidden'));
              accountWishlistEl?.classList.remove('hidden');
          }          
            
        }
        } else {
            window.location.href = '/account/login'
          //document.querySelector(".popup-login").classList.add("open");
        }

      
    }
});
let dataFormat = (ele, status) => {
    let prodId = ele.dataset.id;
  
    let allProductGId = [];
    allProductGId.push(prodId); // Add product ID
  
    allProductGId = JSON.stringify(allProductGId);
    let data = {
        customerId: document.querySelector('#customer_ID').value,
        data: {
            "metafield": {
                "namespace": "wishlist",
                "key": "wishlist_product",
                "value": allProductGId,
                "type": "list.product_reference"
            }
        },
      status: status
    };
    let url = 'https://shopify-app-722384162149.us-central1.run.app/api/wishlist';
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: "follow"
    };
    fetchMethod(url, requestOptions, data);
}
let fetchMethod = (url, requestOptions, data) => {
    fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => {
            if (result == 'ok') {
                url = window.location.href;
                myHeaders = new Headers();
                myHeaders.append("Content-Type", 'text/html');
                requestOptions = {
                    method: 'GET',
                    headers: myHeaders
                };
                fetchMethod(url, requestOptions, data);
            } else if (result == 404) {
                let loaderDiv = document.querySelector('.loader_div');
                if (loaderDiv) {
                    loaderDiv.classList.remove('hidden');
                }
                alert("Internal server error please try again after somtime");
            } else {
              
                htmlParser(result);
            }
        })
        .catch((error) => {
            console.error(error);
            // alert("Internal Server Error!");
        });
}

let htmlParser = (carthtml) => {
    let loaderDiv = document.querySelector('.loader_div');
    if (loaderDiv) {
        loaderDiv.classList.remove('hidden');
    }
    let parser = new DOMParser();
    let doc = parser.parseFromString(carthtml, 'text/html');
    let wishlistProductWrapper = document.querySelector('.wishlist-input_wrapper')?.innerHTML;
  
    document.querySelector('.wishlist-input_wrapper').innerHTML = wishlistProductWrapper;
    if (doc.querySelector('#product-grid')) {
        let html = doc.querySelector('#product-grid').innerHTML;
        document.querySelectorAll('.product-grid').forEach((item, index) => {
            item.innerHTML = html;
        });
    } else if (doc.querySelector('#wishlist-grid-item')) {
        let html = doc.querySelector('#wishlist-grid-item').innerHTML;
        document.querySelectorAll('.account-wishlist').forEach((item, index) => {
            item.innerHTML = html;
        });
    } else {
       let loaderDiv = document.querySelector('.loader_div');
       if (loaderDiv) {
          loaderDiv.classList.remove('hidden');
       }
    }
}

let allWishlistProduct = () => {
    let wishlistPro = [];
    document.querySelectorAll('.wishlist--product').forEach((item, index) => {
        wishlistPro.push(item.value);
    })
    return wishlistPro;
}